<template>
<div>
  <v-main class="pa-0">
    <v-container>
      <div class="d-flex align-center mb-2">
        <v-sheet><v-img src="../../assets/svg/3013.svg" width="20px"></v-img></v-sheet>
        <p class="ml-2 mr-auto mb-0 text-h6 font-weight-bold">{{$t('プロジェクト')}}</p>
        <p class="my-0 text-subtitle-2">{{$t('プロジェクト')}}一覧</p>
      </div>
      <v-row class="mb-12 mt-4">
        <v-col cols="4">
          <RichViewAndEditor :lidId="$route.params.id" :pageType="$route.name" :foldedByDefault="true"></RichViewAndEditor>
        </v-col>
        <!--プロジェクト一覧-->
        <v-col cols="7">
          <p v-if="projects.length==0" class="mt-4 text-center">{{$t('プロジェクト')}}はまだ作成されていません。</p>
          <v-row>
            <v-col v-for="eachpj in projects" :key="eachpj.data" cols="6">
              <v-card tile class="mx-auto px-0 pj-bk d-flex flex-column" :class="{vtpj:eachpj.condition=='voting',fnpj:eachpj.condition=='voteend'}" height="50vh" @click="getOnePj(eachpj.uid)" color="#F5F5F5" data-testid="gotoUpProject">
                <!--Projectsヘッダー-->
                <v-card-actions class="text-left pa-2 d-flex">
                  <span class="mr-1" v-if="eachpj&&!eachpj.sanka"><v-icon color="deepLava">mdi-new-box</v-icon></span>
                  <v-card-text class="font-weight-regular text-subtitle-2 pa-0 mr-auto" :class="{vtft:eachpj.condition=='voting',fnft:eachpj.condition=='voteend'}">
                    <span class="deepAlgae--text mr-1" :class="{vtft:eachpj.condition=='voting',fnft:eachpj.condition=='voteend'}">進行状況</span>
                    <span v-if="eachpj.condition=='voting'">投票中</span>
                    <span v-else-if="eachpj.condition=='voteend'">投票終了</span>
                    <span v-else style="color:#707070;">議論中</span>
                  </v-card-text>
                  <span v-if="eachpj&&eachpj.sanka&&eachpj.pjAdmin&&eachpj.pjAdmin.includes(uid)" class="text-caption faintHoney text-center py-1" style="width:40%">管理者</span>
                </v-card-actions>

                <v-img v-if="eachpj&&eachpj.pjImage_large" width="100%" max-height="15vh" :src="eachpj.pjImage_large" alt=""></v-img>
                <v-img v-else-if="eachpj&&eachpj.pjImage" width="100%" max-height="15vh" :src="eachpj.pjImage" alt=""></v-img>
                <v-img v-else src="../../assets/png/pj.png" width="100%" max-height="15vh"></v-img>

                <v-card-actions class="pa-2" v-if="eachpj.title" style="max-height:16%;">
                  <v-card-text class="font-weight-regular deepAlgae--text pa-0" :class="{vtft:eachpj.condition=='voting',fnft:eachpj.condition=='voteend'}" style="font-size:12px;">
                    <span class="mr-4">{{$t('プロジェクト')}}</span>{{str20(eachpj.title)}}
                  </v-card-text>
                </v-card-actions>

                <!--Projects概要-->
                <v-card-text class="font-weight-regular ma-0 px-2 py-0 pjsummary" style="max-height:20%; font-size:8px;" v-if="eachpj.summary" v-dompurify-html="str80(eachpj.summary)"></v-card-text>

                <!--Projectsフッター-->
                <v-card-actions class="d-flex mt-auto">
                  <v-icon class="ml-auto" v-if="eachpj&&eachpj.counterCm">mdi-forum-outline</v-icon>
                  <p class="mb-0 mt-2 text-caption" v-if="eachpj&&eachpj.counterCm>0">{{ eachpj.counterCm }}</p>
                  <v-icon class="ml-2" v-if="eachpj&&eachpj.counterAm">mdi-message-text</v-icon>
                  <p class="mb-0 mt-2 text-caption" v-if="eachpj&&eachpj.counterAm>0">{{ eachpj.counterAm }}</p>
                </v-card-actions>
              </v-card>              
            </v-col>
          </v-row>

        </v-col>
        <v-col cols="1" class="pl-4 d-flex flex-column justify-center" style="position:fixed;right:0">
          <!--検索-->
          <v-btn color="#399942" icon rounded outlined @click="isAddpj = true" text data-testid="createProject" x-large v-if="false">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
          <!--並び替え-->
          <v-btn color="#399942" icon rounded outlined @click="isAddpj = true" text data-testid="createProject" class="my-2" x-large v-if="false">
            <v-img color="#399942" src="../../assets/svg/5035.svg" width="10px"></v-img>
          </v-btn>
          <!--プロジェクト新規作成-->
          <v-btn icon rounded @click="doSubmit()" text data-testid="createProject" style="background-color:#399942 !important;" x-large v-if="isAuthed&&isAdmin">
            <v-icon color="white">mdi-file-document-plus-outline</v-icon>
          </v-btn>          
        </v-col>
      </v-row>
    </v-container>
  </v-main>

  <!--CreateProject-->
  <v-dialog v-model="isAddpj" width="90vw" persistent @keydown.esc="isAddpj = false">
    <addpj
      :lidusers="lidusers"
      @isaddpj="oneisaddpj"
    ></addpj>
  </v-dialog>

  <!--Project詳細画面-->
  <v-dialog v-model="editpj" v-if="pjuid" persistent @keydown.esc="editpj = false,$emit('openPj', false),pjusers=[],ininwatcher=false" class="ma-0 pa-0 white editpj_row" fullscreen>
    <div :class='[unfold ? "pl80" : "pl312"]'>
      <v-card class="pa-0 ma-0 d-flex flex-column overflow-hidden" height="auto" :class="{colorDis:!modeVote&&!voteSetEdit&&!modeResult,colorVoting:modeVote||voteSetEdit,colorEnd:modeResult}">
        <div tile elevation="0" style="border-bottom-right-radius: 0px;" class="d-flex align-center" height="auto">
          <v-chip v-if="modeVote||voteSetEdit" class="mt-2 ml-2 px-6" dark color="white"  outlined> <span>投票中</span></v-chip>
          <v-chip v-else-if="modeResult" class="mt-2 ml-2 px-6" color="white" outlined><span>投票終了</span></v-chip>
          <v-chip v-else class="mt-2 ml-2 px-6" color="white" outlined><span>議論中</span></v-chip>
          <v-icon :color="modeVote ? 'white' : 'deepLava'" size="40" class="ml-auto pa-1" @click="editpj=false,$emit('openPj', false)">mdi-close-circle</v-icon>
        </div>
        <v-card-text class="text-center py-2 mb-2 text-h5 white--text" style="width:100%; font-weight:700; max-height:40px;" v-if="aboutpj">{{aboutpj.title}}</v-card-text>
        <v-card-text v-if="!isAuthed" class="text-center pa-0 text-caption mt-auto faintHoney" style="height:10px; width:100%; color:#2B2B2B; font-weight:700;" >現在未ログイン状態で閲覧しています。<v-btn class="py-0" text @click="authModal=true" style="text-decoration: underline; color:#008CFF;">ログイン</v-btn> して対話に参加しましょう。</v-card-text>
        <v-card-text v-else-if="aboutpj&&aboutpj.sanka&&aboutpj.pjAdmin&&aboutpj.pjAdmin.includes(uid)" class="text-center pa-0 text-caption mt-auto faintHoney" style="height:20px; width:100%; color:#2B2B2B; font-weight:700;" >あなたはこの{{$t('プロジェクト')}}のファシリテーター（管理者）です</v-card-text>
        <v-card-text v-else-if="aboutLid&&!aboutLid.sanka" class="text-center pa-0 text-caption mt-auto faintHoney" style="height:18px; width:100%; color:#2B2B2B; font-weight:700;" >Lidに参加して、議論に参加しましょう！ <span @click="$store.dispatch('inLid',{lidId:$route.params.id,uid:uid})" style="text-decoration: underline;" class="deepAqua--text">Lidに参加</span></v-card-text>
      </v-card>
      <v-card class="ma-0 editpj_row d-flex overflow-hidden" height="82vh">
        <!--左側プロジェクト詳細-->
        <v-card width="60%">
          <project_dialog_left
            :key="pjuid"
            :pjuid="pjuid"
            :lidid="$route.params.id"
            :pjuser="pjusers"
            :modeVote="modeVote"
            :modeResult="modeResult"
            :pjadmins="pjadmins"
            :aboutpj="aboutpj"
            :newpropj="newpropj"
            :oldpropj="oldpropj"
            @getpjusers="onegetpjusers"
            @updateAn="getPro(pjuid)"
            @pjSetting="settingPj=true"
            @outPj="outPj()"
            @voteStart="doVoteStart()"
            @voteFinish="doVoteFinish()"
            @voteEdit="doVoteEdit()"
          ></project_dialog_left>
        </v-card>
        
        <!--右側プロジェクト詳細-->
        <v-card width="40%">
          <!--投票設定画面-->
          <project_dialog_right_voteset
            v-if="voteSet||voteSetEdit"
            :voteSetEdit="voteSetEdit"
            :voteSet="voteSet"
            :pjuid="pjuid"
            :voteEndTime="voteEndTime"
            :voteStartTime="voteStartTime"
            :voteId="voteId"
            :isAdmitDele="isAdmitDele"
            :isAdmitQuad="isAdmitQuad"
            :isAdmitMulti="isAdmitMulti"
            :isAdmitOpen="isAdmitOpen"
            @iseditpj="oneiseditpj"
            @voteFinish="doVoteFinish()"
            @voteStartReset="voteSet=false,voteSetEdit=false"
          ></project_dialog_right_voteset>
          
          <!--投票画面-->
          <project_dialog_right_vote
            v-else-if="modeVote"
            :pjuid="pjuid"
            :aboutpj="aboutpj"
            :pjusers="pjusers" 
            :pjadmins="pjadmins" 
            :isPermitDeleList="isPermitDeleList" 
            :voteDelePjUserlist="voteDelePjUserlist" 
            :voteUsers="voteUsers" 
            :permitdele="permitdele" 
            :chartData="chartData"
            :userChoice_copy="userChoice" 
            :currentVotes="currentVotes"
            :vote="vote"
            :voteId="voteId"
            :isAdmitDele="isAdmitDele"
            :isAdmitQuad="isAdmitQuad"
            :isAdmitMulti="isAdmitMulti"
            :isAdmitOpen="isAdmitOpen"
            :qn01="qn01"
            :qn02="qn02"
            :qn03="qn03"
            :qn04="qn04"
            :qn05="qn05"
            :qn06="qn06"
            :qn07="qn07"
            :qn08="qn08"
            :qn09="qn09"
            :qn010="qn010"
            :option01="option01"
            :option02="option02"
            :option03="option03"
            :option04="option04"
            :option05="option05"
            :option06="option06"
            :option07="option07"
            :option08="option08"
            :option09="option09"
            :option010="option010"
            @iseditpj="oneiseditpj"
            @getpjusers="onegetpjusers"
          ></project_dialog_right_vote>

          <!--結果画面-->
          <project_dialog_right_result
            v-else-if="modeResult"
            :pjuid="pjuid"
            :aboutpj="aboutpj"
            :pjadmins="pjadmins"
            :chartData="chartData"
            :vote="vote"
            :sum1num="sum1num"
            :sum2num="sum2num"
            :sum3num="sum3num"
            :sum4num="sum4num"
            :sum5num="sum5num"
            :sum6num="sum6num"
            :sum7num="sum7num"
            :sum8num="sum8num"
            :sum9num="sum9num"
            :sum10num="sum10num"
            :sumnum = "sumnum"
          ></project_dialog_right_result>
        
          <!--議論画面-->
          <project_dialog_right_dis
            v-else
            :pjuid="pjuid" 
            :pjadmins="pjadmins"
            :aboutpj="aboutpj"
          ></project_dialog_right_dis>
          <!--EditProjectフッター-->
        </v-card>
      </v-card>
    </div>
  </v-dialog>

  <!--投票締め切り通知画面-->
  <v-dialog v-model="noticeVoteend" width="60%" class="z1000" persistent>
    <v-card class="pt-4 pb-2">
      <v-card-text class="text-center px-8 py-2 pt-6 text-h5 font-weight-bold" style="color:#0F0101;">投票は締め切られました</v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-chip class="mt-4 mx-2 px-6 font-weight-bold" color="#66BAFF" @click="noticeVoteend=false,reload()" dark>確認</v-chip>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--プロジェクト設定-->
  <v-dialog v-model="settingPj" width="80%" class="z1000" persistent>
    <v-card class="pa-4">
      <v-card-actions>
        <h3>{{$t('プロジェクト')}}詳細設定</h3>
        <v-spacer></v-spacer>
        <v-icon @click="settingPj = false,isChangeImage=false,$refs.upImage.removeimage()" color="#ba0009">mdi-close</v-icon>
      </v-card-actions>
      <div class="overflow-y-auto" style="height:66vh;">
        <p style="color:#399942;">{{$t('プロジェクト')}}名</p>
        <v-textarea v-model="setTitle" outlined label="" value="" rows="1"></v-textarea>
        <p style="color:#399942;">担当課</p>
        <v-textarea v-model="setInCharge" outlined label="" value="" rows="1"></v-textarea>
        <p style="color:#399942;">概要</p>
        <quill-editor style="height: auto" v-model="setSummary" :rules="[required,pjsummaryrule]" :options="pjsuEditorOption" no-resize rows="3" class="pt-0 mt-2 mb-8 mx-2 quill-editor_1"></quill-editor>
        <p style="color:#399942;">参考リンク</p>
        <v-textarea v-model="setLink" outlined label="" value="" rows="1"></v-textarea>
        <v-row class="pb-8">
          <v-col cols="6" class="d-flex">
            <p><span style="color:#399942;">管理者</span><br>{{pjadmins.length}}人</p>
            <v-btn class="px-2 rounded-pill ml-12" color="#399942" dark v-if="((pjadmins&&pjadmins.some((el) => el === uid))||isAdmin)&&isAuthed" @click="pjAdmview=true">管理</v-btn>
          </v-col>
          <v-col cols="6" class="d-flex">
            <p><span style="color:#399942;">参加者</span><br>{{pjusers.length}}人</p>
            <v-btn class="px-2 rounded-pill ml-12" color="#399942" dark v-if="((pjadmins&&pjadmins.some((el) => el === uid))||isAdmin)&&isAuthed" @click="pjMemview=true">管理</v-btn>
          </v-col>
        </v-row>  
        <p class="my-0 mt-2 abyss--text"> 画像</p>
        <upImage ref="upImage" @getImageUrl="getImageUrl" :pjImageForEdit="pjImage_large || pjImage"></upImage>        
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="rounded-pill px-2 mr-4 white--text" color="#008CFF" @click="updatePj()" :disabled="setTitle.length==0||setSummary.length==0">変更内容を保存</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  
  <!--Pj管理者画面-->
  <v-dialog
    v-model="pjAdmview"
    width="800"
    persistent class="z1000"
  >
    <listAdm :lidId="$route.params.id" :lidTitle="aboutpj.title" :pjId="pjuid" :pjadmins="pjadmins" mode="pj" @listAdmClose="oneaddAdmin"></listAdm>
  </v-dialog>

  <!--メンバーリスト画面-->
  <v-dialog
    v-model="pjMemview"
    width="800"
    persistent class="z1000"
  >
    <listMem mode="pj" :pjuid="pjuid" @listMemClose="oneaddMember"></listMem>
  </v-dialog> 

  <!--Lid参加確認画面-->
  <v-dialog v-model="LidSankaAlert" width="800" class="z1000">
    <v-card elevation="15" class="pt-6">
      <v-card-actions class="d-flex justify-center align-center">
        <v-img class="mr-4" max-height="100%" max-width="8%" src="../../assets/svg/5007red.svg"></v-img>
        <div>
          <p class="font-weight-bold text-h5 text-center">あなたはこのLidに参加していません。</p>
          <p class="font-weight-bold text-h5 text-center mb-0">このLidに参加しますか？</p>        
        </div>
      </v-card-actions>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-chip class="ma-4 pa-4" @click="LidSankaAlert = false" >参加しない</v-chip>
        <v-chip class="ma-4 pa-4" @click="LidSankaAlert = false, $store.dispatch('inLid',{lidId:aboutlid.id,uid:uid})" color="deepAqua" dark>参加</v-chip>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--サインイン画面-->
  <v-dialog v-model="authModal" width="400px" height="60%">
    <auth-view
      v-if="authModal"
      defaultView="chooseauth"
      @closeModal="closeAuthModal"
    >
    </auth-view>
  </v-dialog>

  <activity_function ref="activityfunc" />
 </div>
</template>

<script>
import Vue from 'vue'
import firebase from "firebase/app"
import "firebase/firestore"
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import VueDOMPurifyHTML from 'vue-dompurify-html'
// import project_dialog_left from '../../components/project/project_dialog_left.vue'
// import project_dialog_right_dis from '../../components/project/project_dialog_right_discussion.vue'
// import project_dialog_right_vote from '../../components/project/project_dialog_right_vote.vue'
// import project_dialog_right_voteset from '../../components/project/project_dialog_right_voteset.vue'
// import project_dialog_right_result from '../../components/project/project_dialog_right_result.vue'
// import addpj from '../../components/project/addpj.vue'
// import listAdm from '../../components/listAdm.vue'
// import listMem from '../../components/listMem.vue'
const project_dialog_left = () => import('../../components/project/project_dialog_left.vue')
const project_dialog_right_dis = () => import('../../components/project/project_dialog_right_discussion.vue')
const project_dialog_right_vote = () => import('../../components/project/project_dialog_right_vote.vue')
const project_dialog_right_voteset = () => import('../../components/project/project_dialog_right_voteset.vue')
const project_dialog_right_result = () => import('../../components/project/project_dialog_right_result.vue')
const addpj = () => import('../../components/project/addpj.vue')
const listAdm = () => import('../../components/listAdm.vue')
const listMem = () => import('../../components/listMem.vue')
const authView = () => import('../../components/auth/authView.vue')
import RichViewAndEditor from '../../components/RichViewAndEditor.vue'
import activity_function from '../../components/profile/activity_function.vue'
import upImage from '../../components/project/project_upImage.vue'
Vue.use(VueDOMPurifyHTML)
export default {
/* eslint-disable */ 
  components:{
    quillEditor,
    project_dialog_left,
    project_dialog_right_dis,
    project_dialog_right_vote,
    project_dialog_right_voteset,
    project_dialog_right_result,
    addpj,
    listAdm,
    listMem,
    activity_function,
    RichViewAndEditor,
    authView,
    upImage
  },
  name:'app',
  props:{
    unfold: Boolean
  },
  data: (vm) => ({
    db: null,

    // dialog
    editpj: false,
    isAddpj: false,
    settingPj:false,
    noticeVoteend:false,
    LidSankaAlert: false,
    authModal: false,
    pjEditorOption: {
      modules: {
        toolbar: [
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
          ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          //['blockquote', 'code-block'],
          //[{ 'header': 1 }, { 'header': 2 }],               // custom button values
          //[{ 'list': 'ordered'}, { 'list': 'bullet' }],
          //[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
          //[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
          //[{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
          //[{ 'font': [] }],
          [{ 'align': [] }],
          ['image'],
          //['clean']                                         // remove formatting button
        ]
      },
      placeholder: "ここに入力してください",
    },

    // プロジェクト関係変数
    pjuid: '',
    projects: [],
    aboutpj: {},
    pjan: vm.pjanInject,
    propj: [],
    newpropj:{},
    oldpropj:[],
    vote: [],
    editpjnotice:'',
    removeReason: "",
    isProjectQueryOpen: true,
    getPjs_type: "added",
    pjImage: "",
    pjImage_large: "",
    isChangeImage: false,

    //condition
    modeVote: vm.voteInject,
    modeResult: false,
    voteSet: false,
    voteSetEdit: false,

    //user
    pjusers: [],
    pjadmins:[],
    
    //dialog
    pjAdmview:false,
    pjMemview:false,

    //settingPj
    setTitle: "",
    setInCharge: "",
    setSummary: "",
    setLink: "",
    
    //vote
    voteStartTime: null,
    voteEndTime: null,
    isVoteEndNow: false,
    voteId: "",
    voteDelePjUserlist: [],
    voteUsers: {},
    qvMaxLimit: 100,
    qn01: 0,
    qn02: 0,
    qn03: 0,
    qn04: 0,
    qn05: 0,
    qn06: 0,
    qn07: 0,
    qn08: 0,
    qn09: 0,
    qn010: 0,
    voteType: "賛成・反対",
    currentVotes: [],
    isAdmitOpen: "open",
    isAdmitMulti: false,
    isAdmitDele: true,
    isAdmitQuad: false,
    isPermitDeleList: {},
    option01: false,
    option02: false,
    option03: false,
    option04: false,
    option05: false,
    option06: false,
    option07: false,
    option08: false,
    option09: false,
    option010: false,
    sum1num: null,
    sum2num: null,
    sum3num: null,
    sum4num: null,
    sum5num: null,
    sum6num: null,
    sum7num: null,
    sum8num: null,
    sum9num: null,
    sum10num: null,
    sumnum: null,
    permitdele: true,
    userChoice: {
      option1: 0,
      option2: 0,
      option3: 0,
      option4: 0,
      option5: 0,
      option6: 0,
      option7: 0,
      option8: 0,
      option9: 0,
      option10: 0,
      isDoDele: false,
      deleTo: ""
    },
    userChoice0: {
      option1: 0,
      option2: 0,
      option3: 0,
      option4: 0,
      option5: 0,
      option6: 0,
      option7: 0,
      option8: 0,
      option9: 0,
      option10: 0,
      isDoDele: false,
      deleTo: ""
    },
    ininwatcher: false,
    deleList: [],
    undeleList: [],
    // 結果
    chartData: {
      labels: [],
      datasets: [
        {
          label: '投票結果',
          data:[],
          backgroundColor: [
            '#008CFF',
            '#399942',
            '#E64550',
            '#E05922',
            '#99d1ff',
            '#6eff66',
            '#ff66ba',
            '#ffab66',
            '#993d70'
          ],
          borderColor: [
            '#dcdcdc',
            '#dcdcdc',
            '#dcdcdc',
            '#dcdcdc',
            '#dcdcdc',
            '#dcdcdc',
            '#dcdcdc',
            '#dcdcdc',
            '#dcdcdc',
            '#dcdcdc'
          ],
          borderWidth: 1
        }
      ]
    },
    // ルール
    pjsummaryrule: v => v.length <= 400 || '入力は400文字までです',
    required: v => !!v || "必ず入力してください",
    pjsuEditorOption:{
      modules: {
        toolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        //['blockquote', 'code-block'],
        //[{ 'header': 1 }, { 'header': 2 }],               // custom button values
        //[{ 'list': 'ordered'}, { 'list': 'bullet' }],
        //[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        //[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
        //[{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        //[{ 'font': [] }],
        [{ 'align': [] }],
        //['clean']                                         // remove formatting button
        ]
      }
    },
  }),
  inject: { 
    pjanInject : {default : ''},
    voteInject : {default: false},
  },
  mounted() {
    this.db = firebase.firestore() // dbインスタンスを初期化
    this.getPjs()
    this.chartData.labels = [1,2,3,4]
  },
  watch: {
    $route: 'getPjs'
  },
  computed:{
    members(){
      return this.$store.state.members
    },
    namelist(){
      return this.$store.state.namelist
    },
    config(){
      return this.$store.state.config
    },
    lidusers(){
      return this.$store.state.lidusers
    },
    isAdmin(){
      if(this.$store.state.isAdmin||(this.aboutLid&&this.aboutLid.lidAdmin&&this.aboutLid.lidAdmin.includes(this.uid))) return true
    },
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
    currentName() {
      return this.$store.state.auth.user.displayName;
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    lid(){
      return this.$store.state.lid
    },
    alid(){
      return this.$store.state.alid
    },
    aboutLid() {
      return this.$store.state.aboutLid
    },
  },
  methods: {
    getImageUrl(pjImage, pjImage_large){
      this.pjImage = pjImage;
      this.pjImage_large = pjImage_large;
      this.isChangeImage = true
    },
    // プロジェクト新規作成関係
    doSubmit(){
      if(this.aboutLid.sanka){
        this.isAddpj = true
      }
      else this.LidSankaAlert = true
    },

    // 参加関係
    inPj(el){
      // プロジェクトを押した時点で参加扱い
      const self = this
      self.db.collection("0").doc(self.$route.params.id).collection("project").doc(el).collection("user").doc(self.uid).set({
        isActive:true,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        uid: this.uid
      },{merge:true}).then(function(docRef) {
        // 保存に成功した時
        //console.log("USERss Document written with ID: ", docRef.id)
        let index = self.projects.findIndex(pj => pj.uid == el)
        self.$set(self.projects[index],"sanka",true)
        self.$set(self.aboutpj,"sanka",true)
        console.log("Pj参加完了",el,index,self.projects[index].sanka)
      }).catch(function(error) {
        // 保存に失敗した時
        console.error("Pj参加失敗: ", error)
      })
    },
    outPj(){
      const self = this
      self.db.collection("0").doc(self.$route.params.id).collection("project").doc(self.pjuid).collection("user").doc(self.uid).set({
        isActive:false,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        uid: this.uid
      },{merge:true}).then(function(docRef) {
        // 保存に成功した時
        //console.log("USERss Document written with ID: ", docRef.id)
        let index = self.projects.findIndex(pj => pj.uid == self.pjuid)
        self.$set(self.projects[index],"sanka",false)
        console.log("Pj退出完了",self.pjuid,index,self.projects[index].sanka)
      }).catch(function(error) {
        // 保存に失敗した時
        console.error("Pj退出登録失敗: ", error)
      })
    },

    // プロジェクト取得関係
    getPjs() { 
      //プロジェクト取得
      let self = this,pjindex,onepj,projectuids = []
      this.projects = []
      this.db.collection("0").doc(this.$route.params.id).collection('project').where("isActive", "==", true).orderBy('sort', 'desc')
      .onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          self.getPjs_type = change.type
          //console.log('PROJECTchange: ', change.doc.data())
          if (change.type === "added") { //新規追加
            onepj = change.doc.data()
            self.$set(onepj, `uid`, change.doc.id)
            self.$set(onepj, `sanka`, false)
            self.projects.push(onepj)
            projectuids.push(change.doc.id)
            if(self.$route.query.id == change.doc.id && self.isProjectQueryOpen){
              // ?id=*** のところにプロジェクトidがついている場合は当該プロジェクトを開く
              //console.log("id",self.$route.query.id)
              self.getOnePj(self.$route.query.id)
              self.isProjectQueryOpen = false
            }
            //console.log("added: ",change.doc.id,change.doc.data())
          }
          if (change.type === "modified") {
            pjindex = self.projects.findIndex((el)=>el.uid === change.doc.id)
            //console.log(pjindex,"Modified: ", change.doc.id,change.doc.data())
            self.projects.splice(pjindex,1,change.doc.data())
            self.projects[pjindex].uid = change.doc.id
            self.aboutpj = self.projects[pjindex]
            //console.log("newpj:",self.projects[pjindex])
            if(self.pjuid===change.doc.id){
              //self.getOnePj(self.pjuid) 必要かどうか不明
            }
          }
          if (change.type === "removed") {
            pjindex = self.projects.findIndex((el)=>el.uid === change.doc.id)
            //console.log(pjindex,"Removed: ", change.doc.data())
            self.projects.splice(pjindex,1)
          }
          if (self.getPjs_type === "added") {
            self.db.collection("0").doc(self.$route.params.id).collection("project").doc(change.doc.id).collection("user").doc(self.uid).get().then((doc) => {
              if (doc.exists) {
                pjindex = self.projects.findIndex((el)=>el.uid === change.doc.id)
                if(doc.data().isActive) self.$set(self.projects[pjindex],"sanka",true)
              }
              //console.log("pjtest",doc.data().isActive)
            }).catch((error) => {
              console.log("PJ参加設定エラー", error);
            });
          }
        })
      })
    },

    //プロジェクト読込関係の関数
    getOnePj(pjuid){// 選択したプロジェクト情報の取得、aboutpjに収納
    // クリックしたプロジェクトの詳細情報を取得するのでaboutpjに格納されるプロジェクトは1件のみ
    // つまり格納される配列は1つしかないのでforeachも1回しか実行されないはず。
    // getpjはあくまでプロジェクトページにプロジェクト一覧で表示させるだけのもの
      this.voteSet=false,this.voteSetEdit=false,this.modeVote=false,this.modeResult=false,this.aboutpj = {},this.newpropj = {},this.oldpropj = [] //初期化
      this.pjuid = pjuid //今開いているプロジェクトIDを取得
      this.aboutpj = this.projects.find(el => el.uid == pjuid)
      if(this.isAuthed&&this.aboutLid&&this.aboutLid.sanka&&!this.aboutpj.sanka) this.inPj(pjuid) //Lidに参加していて、PJにまだ参加していない場合は参加処理をする

      this.getOnePj2(pjuid)
    },
    getOnePj2(pjuid){ //getOnePjで取得したプロジェクト情報をもとに処理を続ける
      //console.log(pjuid,this.pjuid,"get One Pj2",this.aboutpj,this.aboutpj.basedIdeas)
      // set pj
      this.setTitle = this.aboutpj.title
      if(this.aboutpj&&this.aboutpj.inCharge) this.setInCharge = this.aboutpj.inCharge
      this.setSummary = this.aboutpj.summary
      if(this.aboutpj&&this.aboutpj.link) this.setLink = this.aboutpj.link

      if(this.aboutpj&&this.aboutpj.pjImage_large) this.pjImage_large = this.aboutpj.pjImage_large
      if(this.aboutpj&&this.aboutpj.pjImage) this.pjImage = this.aboutpj.pjImage
      //console.log(pjuid,"getOnePj",this.aboutpj)

      //pjAdmin
      if(this.aboutpj&&this.aboutpj.pjAdmin) this.pjadmins = this.aboutpj.pjAdmin
      else this.pjadmins = []

      //プロジェクトユーザー取得
      this.getPjUsers(pjuid)

      //案取得
      this.getPro(pjuid)

      //議論、投票、結果に分けて処理をはじめる
      if(this.aboutpj.condition=='voting'){ //投票
        this.getVote(pjuid)
        this.modeVote = true
      }
      else if(this.aboutpj.condition=='voteend'){ //結果
        //結果画面のラベル設定
        this.getVote(pjuid)
        this.modeResult = true
      }

      //プロジェクトを開く
      if(!this.settingPj){
        this.editpj = true
        this.$emit('openPj', true)
      } 
    },
    getPjUsers(pjuid){ //PJユーザ情報取得
      //console.log("PjUser処理開始")
      let self = this
      let collection = this.db.collection("0").doc(this.$route.params.id).collection("project").doc(pjuid).collection("user")
      collection.get().then((querySnapshot) => {
        self.pjusers=[]
        querySnapshot.forEach((doc) => {
          //console.log("user",doc.id,self.uid,pjuid)
          let data = doc.data()
          if(!data.uid) self.$set(data,"uid",doc.id) //uidがセットされてない場合はidをセットする
          if(doc.id=="admin"){
            //adminは別の場所で管理することになっているのでこのifは今後撤去する
            //this.pjadmins = doc.data().pjadminuid
            //console.log("PJADMINUID:"+doc.data().pjadminuid)
          }
          else{
            if(data.isActive) self.pjusers.push(data)
          }
          if(doc.id === self.uid){
            self.permitdele = data.isPermitDele
          }
          self.isPermitDeleList[data.uid] = data.isPermitDele
        })
        //console.log("USER:",this.pjusers,self.pjusers.some((el) => el.uid === self.uid))
        this.$store.dispatch('setPj',{
          aboutpj: self.aboutpj,
          pjusers: self.pjusers,
          pjadmins: self.pjadmins
        })
        // 委任先を表示するための準備
        self.voteDelePjUserlist = self.pjusers.filter(el => el.uid !== self.uid)
      })
    },
    getPro(pjuid){ //案：案取得
      let self = this
      this.propj = []
      this.db.collection("0").doc(this.$route.params.id).collection("project").doc(pjuid).collection("proposals").orderBy('createdAt', 'desc').get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          //console.log("案取得ID"+doc.id, " => ", doc.data())
          let pro = doc.data()
          self.$set(pro,"id",doc.id)
          if(!pro.sort&&pro.date) self.$set(pro,"sort",pro.date)
          self.propj.push(pro)
        })
        //新しい案に収納
        self.newpropj = self.propj[0]
        //古い案に収納
        self.oldpropj = self.propj
        self.oldpropj.shift()
      })
      .catch((error) => {
        //console.log("Error getting documents: ", error)
        alert("Error!:"+error)
      })
    },

    //投票関係の関数
    //投票読込
    getVote(pjuid){ //投票中に取得する投票読込のための関数
      //console.log("投票取得")
      let self = this, merryChristmas = false
      this.vote=[]
      self.isAdmitQuad = false
      let collection = this.db.collection("0").doc(this.$route.params.id).collection("project").doc(pjuid).collection("votes").orderBy("createdAt", "desc").limit(1);
      collection.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          //console.log(`投票：${doc.id} => ${doc.data()}`)
          self.vote.push(doc.data())
          self.voteId = doc.id
          self.isAdmitDele = doc.data().isAdmitDele //委任可否情報取得
          self.isAdmitQuad = doc.data().isAdmitQuad  //クアドラにするかどうか情報取得
          self.isAdmitMulti = doc.data().isAdmitMulti //複数選択を認めるか否か
          self.isAdmitOpen = doc.data().isAdmitOpen //公開投票にするかどうか
          self.voteStartTime = doc.data().voteStartAt
          self.voteEndTime = doc.data().voteEndAt
          if(doc.data().options.n5) merryChristmas = true
          if(self.isAdmitQuad){
            self.sum1num = doc.data().options.q1
            self.sum2num = doc.data().options.q2
            self.sum3num = doc.data().options.q3
            self.sum4num = doc.data().options.q4
            self.sum5num = doc.data().options.q5
            self.sum6num = doc.data().options.q6
            self.sum7num = doc.data().options.q7
            self.sum8num = doc.data().options.q8
            self.sum9num = doc.data().options.q9
            self.sum10num = doc.data().options.q10
          }
          else{
            self.sum1num = doc.data().options.n1.length+doc.data().optionsDele.n1.length
            self.sum2num = doc.data().options.n2.length+doc.data().optionsDele.n2.length
            self.sum3num = doc.data().options.n3.length+doc.data().optionsDele.n3.length
            self.sum4num = doc.data().options.n4.length+doc.data().optionsDele.n4.length
            if(merryChristmas){
              self.sum5num = doc.data().options.n5.length+doc.data().optionsDele.n5.length
              self.sum6num = doc.data().options.n6.length+doc.data().optionsDele.n6.length
              self.sum7num = doc.data().options.n7.length+doc.data().optionsDele.n7.length
              self.sum8num = doc.data().options.n8.length+doc.data().optionsDele.n8.length
              self.sum9num = doc.data().options.n9.length+doc.data().optionsDele.n9.length
              self.sum10num = doc.data().options.n10.length+doc.data().optionsDele.n10.length               
            }
          }
          self.sumnum = self.sum1num + self.sum2num + self.sum3num + self.sum4num + self.sum5num + self.sum6num + self.sum7num + self.sum8num + self.sum9num + self.sum10num
          self.chartData.labels = doc.data().voteOptions
          self.chartData.datasets[0].data = [self.sum1num,self.sum2num,self.sum3num,self.sum4num,self.sum5num,self.sum6num,self.sum7num,self.sum8num,self.sum9num,self.sum10num]
          self.getVoteUsers(pjuid)
          //console.log(this.vote[0],"投票情報取得ほぼ終了"+JSON.stringify(this.vote[0]))
          self.labelset()
          //投票が終了している場合
          if(this.isVoteEndNow) self.finishvote(pjuid)
        })
      })
    },
    //投票終了
    finishvote(id){ //投票終了、集計処理
      this.getPjUsers(id)
      this.getVoteUsers(id)
      //console.log("投票終了処理開始")
      let self = this
      let q1 = 0,q2 = 0,q3 = 0,q4 = 0,q5 = 0,q6 = 0,q7 = 0,q8 = 0,q9 = 0,q10 = 0
      let n1 = [],n2 = [],n3 = [],n4 = [],n5 = [],n6 = [],n7 = [],n8 = [],n9 = [],n10 = []
      let nd1 = [],nd2 = [],nd3 = [],nd4 = [],nd5 = [],nd6 = [],nd7 = [],nd8 = [],nd9 = [],nd10 = []
      this.deleList = []
      this.undeleList = []
      Object.values(this.voteUsers).forEach( (el) => {
        let myChoice = el.userChoice //自分の投票
        let myuid = el.uid //自分のuid        
        //クアドラティック投票の場合
        if(this.vote[0].isAdmitQuad){
          q1 = q1 + el.userChoice.option1
          q2 = q2 + el.userChoice.option2
          q3 = q3 + el.userChoice.option3
          q4 = q4 + el.userChoice.option4
          q5 = q5 + el.userChoice.option5
          q6 = q6 + el.userChoice.option6
          q7 = q7 + el.userChoice.option7
          q8 = q8 + el.userChoice.option8
          q9 = q9 + el.userChoice.option9
          q10 = q10 + el.userChoice.option10
          //console.log(el,"のクアドラ結果："+q1,q2,q3,q4)
        }
        //通常投票の場合
        else{
          //console.log(el,"の投票結果："+q1,q2,q3,q4)
          if(myChoice.isDoDele){ //委任処理
            if(this.isPermitDeleList[myChoice.deleTo]){
              this.deleList.push(myuid)
              this.voteUsers[myuid].userChoice = this.voteUsers[myChoice.deleTo].userChoice //委任先の投票
              //console.log("委任成立　委任先："+myuid+myChoice.deleTo+this.isPermitDeleList[myChoice.deleTo]+this.voteUsers[myChoice.deleTo].userChoice)
              if(this.voteUsers[myuid].userChoice.option1>0) nd1.push(myuid)
              if(this.voteUsers[myuid].userChoice.option2>0) nd2.push(myuid)
              if(this.voteUsers[myuid].userChoice.option3>0) nd3.push(myuid)
              if(this.voteUsers[myuid].userChoice.option4>0) nd4.push(myuid)
              if(this.voteUsers[myuid].userChoice.option5>0) nd5.push(myuid)
              if(this.voteUsers[myuid].userChoice.option6>0) nd6.push(myuid)
              if(this.voteUsers[myuid].userChoice.option7>0) nd7.push(myuid)
              if(this.voteUsers[myuid].userChoice.option8>0) nd8.push(myuid)
              if(this.voteUsers[myuid].userChoice.option9>0) nd9.push(myuid)
              if(this.voteUsers[myuid].userChoice.option10>0) nd10.push(myuid)
            }
            else{ //委任先が委任投票拒否なので死票
              this.undeleList.push(myuid)
              //console.log("委任先都合により無効票になる。委任先："+myChoice.deleTo+this.isPermitDeleList[myChoice.deleTo]+this.voteUsers[myChoice.deleTo].userChoice)
              this.voteUsers[myuid].userChoice = this.userChoice0
            }
          }
          else{
            if(myChoice.option1>0) n1.push(myuid)
            if(myChoice.option2>0) n2.push(myuid)
            if(myChoice.option3>0) n3.push(myuid)
            if(myChoice.option4>0) n4.push(myuid)
            if(myChoice.option5>0) n5.push(myuid)
            if(myChoice.option6>0) n6.push(myuid)
            if(myChoice.option7>0) n7.push(myuid)
            if(myChoice.option8>0) n8.push(myuid)
            if(myChoice.option9>0) n9.push(myuid)
            if(myChoice.option10>0) n10.push(myuid)
          }
        }
      })
      this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).collection("votes").doc(this.voteId).update({        
        options: {
          n1: firebase.firestore.FieldValue.arrayUnion(...n1),
          n2: firebase.firestore.FieldValue.arrayUnion(...n2),
          n3: firebase.firestore.FieldValue.arrayUnion(...n3),
          n4: firebase.firestore.FieldValue.arrayUnion(...n4),
          n5: firebase.firestore.FieldValue.arrayUnion(...n5),
          n6: firebase.firestore.FieldValue.arrayUnion(...n6),
          n7: firebase.firestore.FieldValue.arrayUnion(...n7),
          n8: firebase.firestore.FieldValue.arrayUnion(...n8),
          n9: firebase.firestore.FieldValue.arrayUnion(...n9),
          n10: firebase.firestore.FieldValue.arrayUnion(...n10),
          q1: q1,
          q2: q2,
          q3: q3,
          q4: q4,
          q5: q5,
          q6: q6,
          q7: q7,
          q8: q8,
          q9: q9,
          q10: q10
        },
        optionsDele: {
          n1: firebase.firestore.FieldValue.arrayUnion(...nd1),
          n2: firebase.firestore.FieldValue.arrayUnion(...nd2),
          n3: firebase.firestore.FieldValue.arrayUnion(...nd3),
          n4: firebase.firestore.FieldValue.arrayUnion(...nd4),
          n5: firebase.firestore.FieldValue.arrayUnion(...nd5),
          n6: firebase.firestore.FieldValue.arrayUnion(...nd6),
          n7: firebase.firestore.FieldValue.arrayUnion(...nd7),
          n8: firebase.firestore.FieldValue.arrayUnion(...nd8),
          n9: firebase.firestore.FieldValue.arrayUnion(...nd9),
          n10: firebase.firestore.FieldValue.arrayUnion(...nd10),
        },
        isVoteFinished: true,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp()
      }).then(function(docRef) {
        //console.log("投票終了処理終了")
        self.db.collection("0").doc(self.$route.params.id).collection('project').doc(id).update({
          condition: "voteend",
          isStartVote: false,
          updatedAt: firebase.firestore.FieldValue.serverTimestamp()
        })
        self.finishvote2()
        self.noticeVoteend = true
      }).catch(function(error) {
        console.error("votes Error adding document: ", error)
        alert("投票終了設定中にエラーが発生しました。もう一度やり直すか、管理者にお問い合わせください。エラー内容:"+error)
      })
      this.isVoteEndNow = false
      //console.log("EndFinishvote")
    },
    finishvote2(){
      console.log("委任先通知",this.$route.params.id,this.pjuid,this.aboutpj,this.deleList,this.undeleList)
      firebase.functions().httpsCallable('notifyDele')({
        lidid: this.$route.params.id,
        pjid: this.pjuid,
        pjtitle: this.aboutpj.title,
        deleList: this.deleList,
        undeleList: this.undeleList
      })
    },
    //チャート用のラベル設定
    labelset(){
      if(this.vote[0]&&this.vote[0].voteType==='quad'){
        this.chartData.datasets[0].backgroundColor= [
          '#008CFF',
          '#399942',
          '#E64550',
          '#E05922',
          '#99d1ff',
          '#6eff66',
          '#ff66ba',
          '#ffab66',
          '#993d70'
        ]
      }
      if(this.vote[0]&&this.vote[0].voteType==='賛成・反対'){
        this.chartData.datasets[0].backgroundColor= [
          '#399942',
          '#BA0009',
        ]
      }
      if(this.vote[0]&&this.vote[0].voteType==='自由選択肢'){
        this.chartData.datasets[0].backgroundColor= [
          '#008CFF',
          '#399942',
          '#E64550',
          '#E05922',
          '#99d1ff',
          '#6eff66',
          '#ff66ba',
          '#ffab66',
          '#993d70',
          '#BA0009',
        ]
      }
    },    
    getVoteUsers(pjuid){
      let self = this, isExistMyuid = false
      self.option01 = false
      self.option02 = false
      self.option03 = false
      self.option04 = false
      self.option05 = false
      self.option06 = false
      self.option07 = false
      self.option08 = false
      self.option09= false
      self.option010 = false
      self.qn01 = 0
      self.qn02 = 0
      self.qn03 = 0
      self.qn04 = 0
      self.qn05 = 0
      self.qn06 = 0
      self.qn07 = 0
      self.qn08 = 0
      self.qn09 = 0
      self.qn010 = 0
      this.userChoice=this.userChoice0
      let collection = this.db.collection("0").doc(this.$route.params.id).collection("project").doc(pjuid).collection("votes").doc(this.voteId).collection("voteusers")
      collection.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          //console.log(`投票ユーザー：${doc.id} => ${doc.data()}`)
          self.voteUsers[doc.id] = doc.data()
          if(doc.id === self.uid){
            isExistMyuid = true
            let myVote = doc.data()
            self.userChoice = myVote.userChoice
            // 投票情報復元
            if(self.isAdmitQuad){
              self.qn01 = doc.data().userChoice.option1
              self.qn02 = doc.data().userChoice.option2
              self.qn03 = doc.data().userChoice.option3
              self.qn04 = doc.data().userChoice.option4
              self.qn05 = doc.data().userChoice.option5
              self.qn06 = doc.data().userChoice.option6
              self.qn07 = doc.data().userChoice.option7
              self.qn08 = doc.data().userChoice.option8
              self.qn09 = doc.data().userChoice.option9
              self.qn010 = doc.data().userChoice.option10
            }
            if(!self.isAdmitQuad&&doc.data().userChoice.option1>0) self.option01 = true
            if(!self.isAdmitQuad&&doc.data().userChoice.option2>0) self.option02 = true
            if(!self.isAdmitQuad&&doc.data().userChoice.option3>0) self.option03 = true
            if(!self.isAdmitQuad&&doc.data().userChoice.option4>0) self.option04 = true
            if(!self.isAdmitQuad&&doc.data().userChoice.option5>0) self.option05 = true
            if(!self.isAdmitQuad&&doc.data().userChoice.option6>0) self.option06 = true
            if(!self.isAdmitQuad&&doc.data().userChoice.option7>0) self.option07 = true
            if(!self.isAdmitQuad&&doc.data().userChoice.option8>0) self.option08 = true
            if(!self.isAdmitQuad&&doc.data().userChoice.option9>0) self.option09 = true
            if(!self.isAdmitQuad&&doc.data().userChoice.option10>0) self.option010 = true
          }
        }),
        //console.log("getvoteusets",this.userChoice,self.voteUsers)
        self.currentVote() //現時点での投票状況を取得
        //console.log("noMyuid,isExistMuuid:",isExistMyuid)
        if(this.isAuthed&&!isExistMyuid){
          //console.log("noMyuid,isExistMuuid:",isExistMyuid)
          self.db.collection("0").doc(self.$route.params.id).collection("project").doc(pjuid).collection("votes").doc(self.voteId).collection("voteusers").doc(self.uid).set({
            uid: self.uid,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
            userChoice: self.userChoice0
          }).then(function(docRef) {
            //console.log("USERs Document written with ID: ", docRef.id)
            //console.log("voteユーザ登録完了")
          }).catch(function(error) {
            console.error("voteユーザ登録失敗: ", error)
            alert("Error!:"+error)
          })
        }
      })
    },
    currentVote(){
      let n1=0,n2=0,n3=0,n4=0,n5=0,n6=0,n7=0,n8=0,n9=0,n10=0
      Object.keys(this.voteUsers).forEach(el => {
        n1 =  n1 + this.voteUsers[el].userChoice.option1
        n2 =  n2 + this.voteUsers[el].userChoice.option2
        n3 =  n3 + this.voteUsers[el].userChoice.option3
        n4 =  n4 + this.voteUsers[el].userChoice.option4
        n5 =  n5 + this.voteUsers[el].userChoice.option5
        n6 =  n6 + this.voteUsers[el].userChoice.option6
        n7 =  n7 + this.voteUsers[el].userChoice.option7
        n8 =  n8 + this.voteUsers[el].userChoice.option8
        n9 =  n9 + this.voteUsers[el].userChoice.option9
        n10 =  n10 + this.voteUsers[el].userChoice.option10
      })
      this.currentVotes[0] =  n1
      this.currentVotes[1] =  n2
      this.currentVotes[2] =  n3
      this.currentVotes[3] =  n4
      this.currentVotes[4] =  n5
      this.currentVotes[5] =  n6
      this.currentVotes[6] =  n7
      this.currentVotes[7] =  n8
      this.currentVotes[8] =  n9
      this.currentVotes[9] =  n10
    },

    // プロジェクト変更関係
    updatePj(){
      let self = this
      this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).set({
        title: this.setTitle,
        name: this.setTitle,
        summary: this.setSummary,
        inCharge: this.setInCharge,
        link: this.setLink,
        pjImage: this.pjImage,
        pjImage_large: this.pjImage_large,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      },{merge:true}).then(function(docRef) {
        // 保存に成功した時
        //console.log("Document written with ID: ", docRef.id)
        self.settingPj = false
        self.isChangeImage = false
        self.pjImage = ""
        self.pjImage_large = ""
        self.$refs.upImage.removeimage()
      }).catch(function(error) {
        // 保存に失敗した時
        console.error("Error adding document at updatepj: ", error)
      })
    },

    //事務的関数
    // プロジェクトの文字数抜粋
    str80(el){
      if(el.length>60) el = el.substr(0, 60) + '...'
      return el
    },
    str20(el){
      if(el.length>20) el = el.substr(0, 20) + '...'
      return el
    },
    minusone(num){
      return Math.round(num - 1)
    },
    scrollBottom() { //スクロール
      //window.scrollToだと後ろの画面が動いてしまう
      this.$nextTick(() => {
        window.scrollTo(0, document.body.scrollHeight)
      })
    },
    reload(){
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    },

    //コンポーネントからのデータ受け取り
    oneaddAdmin(el){
      this.pjAdmview = el
    },
    oneaddMember(el){
      this.pjMemview = el
    },
    oneiseditpj(el){
      // ダイアログを閉じる
      this.editpj = el
      this.$emit('openPj', el)
      this.ininwatcher=false
      this.voteSet = false
      this.voteSetEdit = false
    },
    onegetpjusers(el){
      if(el===true) {this.getPjUsers(this.pjuid)}
    },
    oneisaddpj(el){
      this.isAddpj = el;
    },
    doVoteStart(){
      this.voteSet = true
    },
    doVoteFinish(){
      this.isVoteEndNow = true    
      this.getVote(this.pjuid)
    },
    doVoteEdit(){
      this.voteSetEdit = false
    },
    closeAuthModal() {
      this.authModal = false
    },
    /*
    念のため残しておく関数
    move() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    },
    */
  },
}
</script>
<style>
.z1000{
	z-index: 1000 !important;
}
</style>
<style scoped>
.colorDis{
  background-color: #399942;
}
.colorVoting{
  background-color: #BA0009;
}
.colorEnd{
  background-color: #707070;
}
.pl312{
  padding-left:312px !important;
}
.pl80{
  padding-left:80px !important;
}
.pjsummary >>> p{
  margin-bottom: 0px !important;
}
.quill-editor_1{
  height: 150px;
}
.pj-bk{
  border-left: medium solid #B6E3BA !important;
  border-right: medium solid #B6E3BA !important;
}
.vtpj{
  border-left: medium solid #E64550 !important;
  border-right: medium solid #E64550 !important;
}
.fnpj{
  border-left: medium solid #707070 !important;
  border-right: medium solid #707070 !important;
}
.vtft{
  color: #E64550 !important;
}
.fnft{
  color: #707070 !important;
}
.test > div > input {
    border: 1px ridge #333333;
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    background-color: blue;
}
*{
  font-family:mplus-2c-medium !important;
}
::-webkit-scrollbar {
  display: none;
}
.editpj_row::-webkit-scrollbar{
  display: none;
}
/*
::-webkit-scrollbar-track {
background-color: rgba(120, 170, 210,0.3);
border-radius: 100px;
}
::-webkit-scrollbar-thumb {
background: #78aad2;
border-radius: 100px;
width: 130px;
}
*/
</style>